module.exports = __webpack_public_path__ + "img/logo-timebinder-icon.b39767ee.svg";